import { createStore, combineReducers } from 'redux'
// import {  } from 'react-redux'
// import { createStore } from 'redux'

import DataPageReducer from './DataPageReducer'
import language from './Language'

export default createStore(combineReducers({ 
    DataPageReducer, language
}))